import equities from "./equities"
import fixedIncome from "./fixed-income"

export default {
    equities,
    fixedIncome
}
